<template>
  <v-main>

    <v-container
        id="view-account-container"
        fluid
        tag="section"
        v-if="user"
    >

      <base-material-card
          icon="mdi-account-details-outline"
          class="px-5 py-3"
      >


        <div class="page-messages">
          <shared-page-messages :error-messages="errorMessages"
                                :warning-messages="warningMessages"
                                :success-messages="successMessages">
          </shared-page-messages>
        </div>

        <v-row>
          <v-col
              cols="12"
              sm="3"
              class="font-weight-medium"
          >
            Account Number:
          </v-col>
          <v-col
              cols="12"
              sm="4"
          >
            {{ user.accountNumber }}
          </v-col>
        </v-row>

        <v-row>
          <v-col
              cols="12"
              sm="3"
              class="font-weight-bold"
          >
            Name:
          </v-col>
          <v-col
              cols="12"
              sm="4"
          >
            {{ user.names }}
          </v-col>
        </v-row>

        <v-row>
          <v-col
              cols="12"
              sm="3"
              class="font-weight-bold"
          >
            Address:
          </v-col>
          <v-col
              cols="12"
              sm="4"
          >
            {{ user.address }} <br />
            <span v-if="user.addressLine2"> {{ user.addressLine2 }} <br /> </span>
            {{ user.city }}, {{ user.state }} {{ user.postalCode }} <br />
            <span v-if="user.country"> {{ computedCountry.name }} </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col
              cols="12"
              sm="3"
              class="font-weight-bold"
          >
            Phone Number:
          </v-col>
          <v-col
              cols="12"
              sm="4"
          >
            {{ user.phoneNumber }}
          </v-col>
        </v-row>

        <v-row>
          <v-col
              cols="12"
              sm="3"
              class="font-weight-bold"
          >
            Email Address:
          </v-col>
          <v-col
              cols="12"
              sm="4"
          >
            {{ user.email }}
          </v-col>
        </v-row>

        <v-row>
          <v-col
              cols="12"
              sm="3"
              class="font-weight-bold"
          >
            Gender:
          </v-col>
          <v-col
              cols="12"
              sm="4"
          >
            {{ user.gender }}
          </v-col>
        </v-row>

        <v-row>
          <v-col
              cols="12"
              sm="3"
              class="font-weight-bold"
          >
            Year of Birth:
          </v-col>
          <v-col
              cols="12"
              sm="4"
          >
            {{ user.birthYear }}
          </v-col>
        </v-row>

        <v-row>
          <v-col
              cols="12"
              sm="3"
              class="font-weight-bold"
          >
            ID Number:
          </v-col>
          <v-col
              cols="12"
              sm="4"
          >
            {{ user.idNumber }}
          </v-col>
        </v-row>

        <v-row>
          <v-col
              cols="12"
              sm="3"
              class="font-weight-bold"
          >
            ID Type:
          </v-col>
          <v-col
              cols="12"
              sm="4"
          >
            <span v-if="user.idType">
              {{ user.idType.name }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col
              cols="12"
              sm="3"
              class="font-weight-bold"
          >
            ID Issued By:
          </v-col>
          <v-col
              cols="12"
              sm="4"
          >
            {{ user.idIssuedBy }}
          </v-col>
        </v-row>

        <v-row>
          <v-col
              cols="12"
              sm="3"
              class="font-weight-bold"
          >
            ID Expires:
          </v-col>
          <v-col
              cols="12"
              sm="4"
          >
            {{ user.idExpires }}
          </v-col>
        </v-row>

        <v-row>
          <v-col
              cols="12"
              sm="3"
              class="font-weight-bold"
          >
            User Status:
          </v-col>
          <v-col
              cols="12"
              sm="4"
          >
            {{ userStatusMap[user.status] }}
          </v-col>
        </v-row>

      </base-material-card>
    </v-container>

  </v-main>
</template>

<script>
import api from '@/services/api'
import geoUtils from '@/utils/geography'
import constants from "@/utils/constants";

import {mapGetters} from "vuex";
import SharedPageMessages from '../shared/PageMessages.vue'

export default {
  name: 'CoreViewUserView',
  components: {SharedPageMessages},

  created() {
    this.userId = this.getUserId
    this.fetchUser()
  },

  computed: {
    ...mapGetters({
      getUserId: 'getUserId'
    }),
    computedCountry() {
      return geoUtils.findCountryByCode(this.user.country)
    }
  },

  methods: {
    fetchUser() {
      api
          .fetchUser(this.userId)
          .then(response => {
            this.user = response.data
            this.fetchDependents()
          })
          .catch(err => {
            this.handleError(err)
          })
    },
    fetchDependents() {
      api
          .fetchDependents(this.userId)
          .then(response => {
            this.dependents = response.data
          })
          .catch(err => {
            this.handleError(err)
          })
    },
    handleError(err) {
      let errorMessage = api.parseResponseError(err)
      this.errorMessages.push(errorMessage)
    }
  },

  data() {
    return {
      errorMessages: [],
      successMessages: [],
      warningMessages: [],
      userId: null,
      user: {
        country: 'US',
        idType: {}
      },
      dependents: [],
      userStatusMap: constants.getUserStatusMap()
    }
  }
}
</script>
